import React, { useState } from 'react';
import {
  Box,
  Button,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from '@mui/material';
import useInterveneSx from '../../hooks/useInterveneSx';

const INITIAL_VISIBLE = 5;

export default function UserJourneySection({ journey = [] }) {
  const interveneSx = useInterveneSx();
  const styles = interveneSx.profile.journey;
  const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE);

  const steps = journey.slice(0, visibleCount).map((item, index) => ({
    key: item?.intervene_session_id || index,
    username: item?.username || 'System',
    status: item?.status,
    startTime: item?.timestamp,
    endTime: item?.session_closed_at || null,
  }));

  const formatTime = (value) =>
    value
      ? new Date(value).toLocaleString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        })
      : '—';

  if (!journey.length) {
    return (
      <Typography sx={styles.emptyText}>No journey data available.</Typography>
    );
  }

  return (
    <Box>
      <Stepper orientation="vertical" sx={styles.stepper}>
        {steps.map((step) => (
          <Step key={step.key} active completed>
            <StepLabel>
              <Typography sx={styles.stepTitle}>
                {step.username}
                {step.status ? ` · ${step.status}` : ''}
              </Typography>
              <Typography component="span" sx={styles.stepMeta}>
                Start Intervene · {formatTime(step.startTime)}
              </Typography>
            </StepLabel>
            {step.endTime && (
              <StepContent>
                <Typography component="span" sx={styles.stepMeta}>
                  End Intervene · {formatTime(step.endTime)}
                </Typography>
              </StepContent>
            )}
          </Step>
        ))}
      </Stepper>

      {journey.length > INITIAL_VISIBLE && (
        <Button
          variant="outlined"
          size="small"
          disableElevation
          onClick={() =>
            setVisibleCount((prev) =>
              prev >= journey.length ? INITIAL_VISIBLE : journey.length
            )
          }
          sx={styles.toggleButton}
        >
          {visibleCount >= journey.length ? 'Show Less' : 'Show More'}
        </Button>
      )}
    </Box>
  );
}
